import { render } from "./CreateOrEditInvoice.vue?vue&type=template&id=2ee60fdc"
import script from "./CreateOrEditInvoice.vue?vue&type=script&lang=js"
export * from "./CreateOrEditInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__